import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Checkbox,
  Dropdown,
  Input
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardDrugTransferRequestHistoryUX = (props: any) => {
    return(
      <div
        style={{padding:"5px"}}>
        <div
          id="CardDrugTransferRequestHistoryUX-div-1"
          style={{fontWeight: "bold", fontSize: "1.2rem", marginBottom: "1rem"}}>
          {props.languageUX === "en" ? "Drug request History" : "ประวัติการขอยา"}
        </div>
        <div
          id="CardDrugTransferRequestHistoryUX-div-2"
          style={{display: "flex", alignItems: "center", flexWrap: "wrap"}}>
          
          <div
            id="CardDrugTransferRequestHistoryUX-div-5"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedDivisionRequest}
              id="CardDrugTransferRequestHistoryUX-Checkbox-11"
              onChange={props.handleChangeChecked("checkedDivisionRequest")}>
            </Checkbox>
            <div
              id="CardDrugTransferRequestHistoryUX-div-12"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Request Department by" : "หน่วยงานขอ"}
            </div>
            <Dropdown
              id="CardDrugTransferRequestHistoryUX-Dropdown-13"
              onChange={props.handleChangeValue("selectedDivisionRequest")}
              options={props?.divisionPharmaOptions}
              selection={true}
              value={props?.selectedDivisionRequest}>
            </Dropdown>
          </div>
          <div
            id="CardDrugTransferRequestHistoryUX-div-6"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedDivisionProvider}
              id="CardDrugTransferRequestHistoryUX-Checkbox-14"
              onChange={props.handleChangeChecked("checkedDivisionProvider")}>
            </Checkbox>
            <div
              id="CardDrugTransferRequestHistoryUX-div-15"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Dispensing department by" : "หน่วยงานจ่าย"}
            </div>
            <Dropdown
              id="CardDrugTransferRequestHistoryUX-Dropdown-16"
              onChange={props.handleChangeValue("selectedDivisionProvider")}
              options={props?.divisionPharmaOptions}
              selection={true}
              value={props?.selectedDivisionProvider}>
            </Dropdown>
          </div>
          <div
            id="CardDrugTransferRequestHistoryUX-div-7"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedFilterDate}
              id="CardDrugTransferRequestHistoryUX-Checkbox-17"
              onChange={props.handleChangeChecked("checkedFilterDate")}>
            </Checkbox>
            <div
              id="CardDrugTransferRequestHistoryUX-div-18"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Date" : "วันที่"}
            </div>
            <DateTextBox
              id="CardDrugTransferRequestHistoryUX-DateTextBox-19"
              onChange={props.handleChangeDate("selectedStartDate")}
              value={props?.selectedStartDate}>
            </DateTextBox>
            <DateTextBox
              id="CardDrugTransferRequestHistoryUX-DateTextBox-20"
              onChange={props.handleChangeDate("selectedEndDate")}
              value={props?.selectedEndDate}>
            </DateTextBox>
          </div>
          <div
            id="CardDrugTransferRequestHistoryUX-div-8"
            style={{display: "flex", alignItems: "center", margin: "0 10px 10px 0"}}>
            
            <Checkbox
              checked={props?.checkedCode}
              id="CardDrugTransferRequestHistoryUX-Checkbox-21"
              onChange={props.handleChangeChecked("checkedCode")}>
            </Checkbox>
            <div
              id="CardDrugTransferRequestHistoryUX-div-22"
              style={{margin: "0 5px 0 5px"}}>
              {props.languageUX === "en" ? "Drug requested number " : "เลขที่ใบขอยา"}
            </div>
            <Input
              id="CardDrugTransferRequestHistoryUX-Input-24"
              onChange={props.handleChangeValue("selectedCode")}
              value={props?.selectedCode}>
            </Input>
          </div>
          <Button
            color="blue"
            id="CardDrugTransferRequestHistoryUX-Button-9"
            onClick={props.OnSearch}
            size="tiny"
            style={{marginLeft: "20px"}}>
            {props.languageUX === "en" ? "Search" : "ค้นหา"}
          </Button>
          <Button
            color="yellow"
            id="CardDrugTransferRequestHistoryUX-Button-10"
            onClick={props.OnClear}
            size="tiny"
            style={{marginLeft: "20px"}}>
            {props.languageUX === "en" ? "Clear" : "ล้าง"}
          </Button>
        </div>
        <div
          id="CardDrugTransferRequestHistoryUX-div-3">
          
          <Table
            data={props?.dataDrugTransferRequestHistoryList}
            headers="เลขที่,รายการยา,ขอ,ตรวจ,จ่าย,รับ,สถานะ"
            id="CardDrugTransferRequestHistoryUX-Table-4"
            keys="code,listDrug,request,approve,delivery,receive,statusName"
            minRows="15"
            showPagination={false}
            style={{height: "400px"}}>
          </Table>
        </div>
      </div>
    )
}


export default CardDrugTransferRequestHistoryUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Mon Sep 28 2026 17:34:41 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "style": {
          "type": "code",
          "value": "{padding:\"5px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการขอยา",
          "valueEN": "Drug request History"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\", marginBottom: \"1rem\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", flexWrap: \"wrap\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 4,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props?.dataDrugTransferRequestHistoryList"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "value",
          "value": "เลขที่,รายการยา,ขอ,ตรวจ,จ่าย,รับ,สถานะ"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Table-4"
        },
        "keys": {
          "type": "value",
          "value": "code,listDrug,request,approve,delivery,receive,statusName"
        },
        "minRows": {
          "type": "value",
          "value": "15"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"400px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", alignItems: \"center\", margin: \"0 10px 10px 0\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 9,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้นหา",
          "valueEN": "Search"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Button-9"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnSearch"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 10,
      "name": "Button",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "ล้าง",
          "valueEN": "Clear"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Button-10"
        },
        "onClick": {
          "type": "code",
          "value": "props.OnClear"
        },
        "size": {
          "type": "value",
          "value": "tiny"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"20px\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 11,
      "name": "Checkbox",
      "parent": 5,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedDivisionRequest"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Checkbox-11"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedDivisionRequest\")"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานขอ",
          "valueEN": "Request Department by"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 13,
      "name": "Dropdown",
      "parent": 5,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Dropdown-13"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedDivisionRequest\")"
        },
        "options": {
          "type": "code",
          "value": "props?.divisionPharmaOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedDivisionRequest"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 14,
      "name": "Checkbox",
      "parent": 6,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedDivisionProvider"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Checkbox-14"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedDivisionProvider\")"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "หน่วยงานจ่าย",
          "valueEN": "Dispensing department by"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 16,
      "name": "Dropdown",
      "parent": 6,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Dropdown-16"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedDivisionProvider\")"
        },
        "options": {
          "type": "code",
          "value": "props?.divisionPharmaOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedDivisionProvider"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 17,
      "name": "Checkbox",
      "parent": 7,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedFilterDate"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Checkbox-17"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedFilterDate\")"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "วันที่",
          "valueEN": "Date"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 19,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-DateTextBox-19"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"selectedStartDate\")"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedStartDate"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 20,
      "name": "DateTextBox",
      "parent": 7,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-DateTextBox-20"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeDate(\"selectedEndDate\")"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedEndDate"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Checkbox",
      "parent": 8,
      "props": {
        "checked": {
          "type": "code",
          "value": "props?.checkedCode"
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Checkbox-21"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeChecked(\"checkedCode\")"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบขอยา",
          "valueEN": "Drug requested number "
        },
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0 5px 0 5px\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Input",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardDrugTransferRequestHistoryUX-Input-24"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue(\"selectedCode\")"
        },
        "value": {
          "type": "code",
          "value": "props?.selectedCode"
        }
      },
      "seq": 24,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardDrugTransferRequestHistoryUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
